import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import './index.scss'

export default function BasePopup({
  open = false,
  onClose = () => {},
  onConfirm,
  title = 'Thất bại',
  content = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.',
  closeText = '',
  confirmText = ''
}) {
  useEffect(() => {
    if (!open || typeof document === 'undefined') {
      return undefined
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  if (!open || typeof document === 'undefined') {
    return null
  }

  const footerButtons = []

  if (closeText) {
    footerButtons.push({
      key: 'close',
      text: closeText,
      onClick: onClose,
      variant: 'secondary'
    })
  }

  if (confirmText || (!closeText && !confirmText)) {
    footerButtons.push({
      key: 'confirm',
      text: confirmText || 'Đã hiểu',
      onClick: onConfirm || onClose,
      variant: 'primary'
    })
  }

  return createPortal(
    <div className="BasePopup" role="dialog" aria-modal="true" aria-labelledby="BasePopup_title" aria-describedby="BasePopup_message">
      <button type="button" className="BasePopup_overlay" aria-label="Đóng hộp thoại" onClick={onClose}></button>

      <div className="BasePopup_dialog">
        <div className="BasePopup_content">
          <div className="BasePopup_title" id="BasePopup_title">
            {title}
          </div>
          <div className="BasePopup_message" id="BasePopup_message">
            {content}
          </div>
        </div>

        <div className="BasePopup_footer">
          {footerButtons.map((button) => (
            <button
              key={button.key}
              type="button"
              onClick={button.onClick}
              className={`BasePopup_button BasePopup_button_${button.variant}`.trim()}>
              {button.text}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  )
}
